import { App, plugin, Link } from '@inertiajs/inertia-vue'
import Vue from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faTimes, faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons'

import { faFacebookF, faFacebook} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

InertiaProgress.init()
Vue.use(plugin)
Vue.use(VueAxios, axios)

library.add(faBars)
library.add(faTimes)
library.add(faFacebookF)
library.add(faPhoneAlt)
library.add(faEnvelope)

// inertia-vue 0.8 registreert inertia-link niet meer zelf, in tegenstelling tot
// de 0.4 waarmee de huidige productiebuild is gemaakt. Zonder dit blijven alle
// menulinks onaanklikbare <inertia-link>-elementen.
Vue.component('inertia-link', Link)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

const el = document.getElementById('app')

new Vue({
  
  render: h => h(App, {
    props: {
      initialPage: JSON.parse(el.dataset.page),
      resolveComponent: (name) => {
        return import(`./Pages/${name}`)
        .then(module => module.default)
      },
    },
  })
}).$mount(el)
